const PropagationMonitoringPage = () => import('@/pages/pipeline_monitoring/PropagationMonitoringPage.vue')
const PipelineMonitoringOverviewPage = () => import('@/pages/pipeline_monitoring/PipelineMonitoringOverviewPage.vue')
const ArgillaDatasetMonitoringPage = () => import('@/pages/pipeline_monitoring/ArgillaDatasetMonitoringPage.vue')
const MissedClusterPage = () => import('@/pages/pipeline_monitoring/MissedClusterPage.vue')
const NewsScannersMonitoringPage = () => import('@/pages/pipeline_monitoring/NewsScannersMonitoringPage.vue')
const NewsNLPQueueMonitoringPage = () => import('@/pages/pipeline_monitoring/NewsNLPQueueMonitoringPage.vue')
const NewsQASQueueMonitoringPage = () => import('@/pages/pipeline_monitoring/NewsQASQueueMonitoringPage.vue')
const MlModelsMonitoringPage = () => import('@/pages/pipeline_monitoring/MLModelsMonitoringPage.vue')
const NewsClustersMonitoringPage = () => import('@/pages/pipeline_monitoring/NewsClustersMonitoringPage.vue')

export default [
	{
		path: '/propagation_monitoring',
		component: PropagationMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/argilla_dataset_generation',
		component: ArgillaDatasetMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/missed_clusters_monitoring',
		component: MissedClusterPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/pipeline_monitoring_overview',
		component: PipelineMonitoringOverviewPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/news_scanner_monitoring',
		component: NewsScannersMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/news_nlp_queue_monitoring',
		component: NewsNLPQueueMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/news_qas_queue_monitoring',
		component: NewsQASQueueMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/mlmodels_monitoring',
		component: MlModelsMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	},
	{
		path: '/news_stories_clustered',
		component: NewsClustersMonitoringPage,
		props: {
			permission: ['pipeline_monitoring', 'r']
		}
	}
]
